import { debug as debugGen } from "debug";
import { LatestTrace } from "../types";
import { ClientStore } from "./Client";
import { BrowserStore } from "./Browser";
import { InlinePageStore } from "./InlinePage";
import { IframeStore } from "./Iframe";
import { StorePartialTrace } from "./AbstractStore";

const debug = debugGen("vtTracker:store");

export const client = new ClientStore();
export const browser = new BrowserStore();
export const inline = new InlinePageStore();
export const iframe = new IframeStore();

export async function setTrace(key: string, data: LatestTrace): Promise<void> {
    try {
        inline.setItem(data);
        await iframe.setItem(key, data);
        await browser.setItem(key, data);
        await client.setItem(key, data);
    } catch (err) {
        debug("set trace error: %o", err);
    }
}

export function getTrace(key: string): Promise<StorePartialTrace> {
    debug("get latest click trace");

    return browser
        .getItem(key)
        .then(d => {
            if (Object.keys(d).length <= 0) {
                throw new Error("no localstorage trace");
            }

            return d;
        })
        .catch((err: Error) => {
            debug(`browser trace fail ${err.message} %o`, err);

            return iframe.getItem(key);
        })
        .catch((err: Error) => {
            debug(`iframe trace fail ${err.message} %o`, err);

            return client.getItem(key);
        })
        .catch((err: Error) => {
            debug(`client trace fail ${err.message} %o`, err);

            return {};
        });
}
